(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ss-home-oct26"] && !Shopify.designMode) return;
  try {
    
class SquidSportCarousel {
  constructor(root) {
    if (root.dataset.carouselReady) return;
    root.dataset.carouselReady = 'true';
    this.track = root.querySelector('[data-sport-track]');
    this.previous = root.querySelector('[data-sport-previous]');
    this.next = root.querySelector('[data-sport-next]');
    this.previous.addEventListener('click', () => this.move(-1));
    this.next.addEventListener('click', () => this.move(1));
    this.track.addEventListener('scroll', () => this.update(), {passive:true});
    this.track.addEventListener('keydown', (event) => {
      if (event.target !== this.track) return;
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); this.move(event.key === 'ArrowRight' ? 1 : -1); }
      if (event.key === 'Home' || event.key === 'End') { event.preventDefault(); this.track.scrollTo({left:event.key === 'Home' ? 0 : this.track.scrollWidth,behavior:this.behavior()}); }
    });
    this.track.addEventListener('wheel', (event) => {
      if (!event.shiftKey || Math.abs(event.deltaX) > Math.abs(event.deltaY)) return;
      event.preventDefault(); this.track.scrollLeft += event.deltaY;
    }, {passive:false});
    this.observer = new ResizeObserver(() => this.update());
    this.observer.observe(this.track);
    this.update();
  }
  behavior() { return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'; }
  move(direction) { this.track.scrollBy({left:direction*Math.max(213,Math.floor(this.track.clientWidth/213)*213),behavior:this.behavior()}); }
  update() { this.previous.disabled = this.track.scrollLeft <= 2; this.next.disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2; }
}
const initSquidSports = () => document.querySelectorAll('[data-sport-carousel]').forEach(root => new SquidSportCarousel(root));
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initSquidSports); else initSquidSports();
document.addEventListener('shopify:section:load',initSquidSports);

  } catch(e) { console.error(e); }
})();
})();
